import { useParams } from "react-router-dom";
import Layout from "../layouts/Layout";
import Breadcrumb from "../components/Breadcrumb";
import ServiceDetailsSection from "../components/Service/ServiceDetailsSection";
import BrandSection from "../components/BrandSection";
import FaqSection from "../components/FaqSection";
import { servicesData } from "../data/servicesData";

const ServiceDetail = () => {
  const { slug } = useParams();
  const service = servicesData.find((s) => s.slug === slug);

  return (
    <Layout>
      <Breadcrumb
        title={service.title}
        parent={{ name: "Trang chủ", path: "/" }}
        parent2={{ name: "Dịch vụ", path: "/dich-vu" }}
      />

      <ServiceDetailsSection service={service} />
      <BrandSection />
      <FaqSection />
    </Layout>
  );
};

export default ServiceDetail;
